import React from 'react';
import { ROUTE_CATEGORIES } from '../constants';
import { RedirectWithQueryParams } from './LegacyRoutes';

export const LEGACY_CATEGORY_ROUTE = [
  <RedirectWithQueryParams
    key="LegacyCategoryRoute"
    from={`/shop/:category(${ROUTE_CATEGORIES})/:subcategory?`}
    to={`/women/products/:category(${ROUTE_CATEGORIES})/:subcategory?`}
    exact
  />,
  <RedirectWithQueryParams
    key="LegacyCategoryShopRoute"
    from="/shop"
    to="/women/products/clothing"
    exact
  />,
  <RedirectWithQueryParams
    key="LegacyCategoryShopNewRoute"
    from="/shop/new"
    to="/women/products/new"
    exact
  />,
  <RedirectWithQueryParams
    key="LegacyBridalEditorial"
    from="/editorial/the-wedding-salon"
    to="/editorial/top-micro-wedding-2021-trends"
    exact
  />,
  <RedirectWithQueryParams
    key="LegacyLaurenEditorial"
    from="/editorial/lauren-santo-domingo"
    to="/shop/laurens-closet"
    exact
  />
];
